
  <div class="header-container">
    <div class="d-flex align-items-center">
      <div class="logo-parent">
        <a href='#' id='justify-icon' (click)="handleClick($event)">
          <span class='menu-icon'>
            <img src={{menuIcon}} alt="">
          </span>
        </a>

        <a href="#">
          <img class="logo-img"  src={{Logo}} alt="">
        </a>
      </div>

    </div>

    <div class="profile-container">
      <div ngbDropdown class="d-inline-block">
        <button type="button" class="btn btn-profile dropdown-toggle" id="dropdownBasic1" ngbDropdownToggle>
          <span class="profile-image">
            <img src={{userProf}} alt="">
          </span>
          {{name}}
        </button>

        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem>Setting</button>
          <button ngbDropdownItem (click)="logout()">Log out</button>
        </div>
      </div>
    </div>
  </div>

